import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { RecoverMemberNumberTypes } from '../Types';

const machine = Machines.onRecoverMemberNumber.machine;

export const recoverMemberNumber = (
  params: RecoverMemberNumberTypes.RecoverMemberNumberServiceRequestType,
): Promise<RecoverMemberNumberTypes.IRecoverMemberNumberServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { recoverMemberNumber };
